module.exports = __webpack_public_path__ + "img/p2_1.cbe8cedc.png";